// extracted by mini-css-extract-plugin
module.exports = {"container":"_1mj6I","cover":"_2CG4M","select":"tzwpU"};